import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { sfx } from "@/audio";
import { reduced } from "./util";

export const pointOf = (el) => {
  const r = el.getBoundingClientRect();
  return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
};

// Coins burst out of `from` (default: screen centre), arc over and land on the UXD counter.
export const flyCoins = (from, n = 12) => window.dispatchEvent(new CustomEvent("xf-coins", { detail: { from, n } }));
// Coins fall from the top of the screen: the shower for big wins.
export const rainCoins = (n = 40) => window.dispatchEvent(new CustomEvent("xf-rain", { detail: { n } }));

const rnd = (a, b) => a + Math.random() * (b - a);

// A coin lands in the counter: a clink, at most one every 110 ms so a shower rattles instead of blaring.
let lastClink = 0;
const landed = () => {
  if (Date.now() - lastClink < 110) return;
  lastClink = Date.now();
  sfx("coin");
};

export function CoinLayer() {
  const [coins, setCoins] = useState([]);
  useEffect(() => {
    const add = (batch, ms) => {
      setCoins((c) => [...c, ...batch]);
      setTimeout(() => setCoins((c) => c.filter((x) => !batch.includes(x))), ms);
    };
    const fly = ({ detail: { from, n } }) => {
      if (reduced()) return;
      const a = from ?? { x: window.innerWidth / 2, y: window.innerHeight / 2 };
      const to = document.querySelector('[data-testid="topbar-uxd"]');
      const b = to ? pointOf(to) : { x: window.innerWidth / 2, y: 40 };
      const id = Date.now();
      const batch = Array.from({ length: n }, (_, i) => {
        const p = { x: a.x + rnd(-70, 70), y: a.y - rnd(30, 110) }, side = Math.random() < 0.5 ? -1 : 1;
        const q = { x: (p.x + b.x) / 2 + side * rnd(40, 120), y: Math.min(p.y, b.y) - rnd(10, 60) };
        return { id: `${id}${i}`, xs: [a.x, p.x, q.x, b.x], ys: [a.y, p.y, q.y, b.y], delay: i * 0.04 };
      });
      batch.forEach((c) => setTimeout(landed, (c.delay + 1.1) * 1000));
      add(batch, 1800 + n * 40);
    };
    const rain = ({ detail: { n } }) => {
      if (reduced()) return;
      const id = Date.now();
      add(Array.from({ length: n }, (_, i) => ({ id: `${id}${i}`, rain: true, x: rnd(0, window.innerWidth), drift: rnd(-60, 60), delay: rnd(0, 1), t: rnd(1.1, 1.9), size: rnd(18, 30) })), 3200);
    };
    window.addEventListener("xf-coins", fly);
    window.addEventListener("xf-rain", rain);
    return () => { window.removeEventListener("xf-coins", fly); window.removeEventListener("xf-rain", rain); };
  }, []);
  return (
    <div className="pointer-events-none fixed inset-0 z-[70] overflow-hidden" aria-hidden="true">
      {coins.map((c) => c.rain ? (
        <motion.span key={c.id} className="coin absolute left-0 top-0 text-[11px]" style={{ width: c.size, height: c.size }}
          initial={{ x: c.x, y: -40, rotateY: 0 }}
          animate={{ x: c.x + c.drift, y: window.innerHeight + 40, rotateY: 720 }}
          transition={{ duration: c.t, delay: c.delay, ease: "easeIn" }}>U</motion.span>
      ) : (
        <motion.span key={c.id} className="coin absolute left-0 top-0 h-6 w-6 text-[11px]"
          initial={{ x: c.xs[0] - 12, y: c.ys[0] - 12, scale: 0.3, opacity: 0 }}
          animate={{ x: c.xs.map((v) => v - 12), y: c.ys.map((v) => v - 12), scale: [0.3, 1.2, 1, 0.6], opacity: [0, 1, 1, 0.9], rotateY: [0, 360, 720, 1080] }}
          transition={{ duration: 1.1, delay: c.delay, times: [0, 0.22, 0.6, 1], ease: "easeInOut" }}>U</motion.span>
      ))}
    </div>
  );
}
